export default __webpack_public_path__ + "static/media/low_light.35a1aeff.svg";